import React from 'react';                  
import ProgramsList from '../../components/ProgramsList';
            
function Home() {                           
  return (                                  
    <ProgramsList />                     
  );     
}        
         
export default Home;  